require './main_content'

FOLLOW_FLYOUT_LOCALSTORAGE_KEY = 'merchant-page-clicked-follow-flyout'
MIN_MODAL_WIDTH = 767

getSessionVariableKey = (placeId) ->
  return "mpp-follow-#{placeId}"

removeFromStorage = (placeId) ->
  sessionStorage?.removeItem getSessionVariableKey(placeId)

getFromStorage = (placeId) ->
  sessionStorage?.getItem getSessionVariableKey(placeId)

setToStorage = (placeId, value) ->
  if sessionStorage?
    sessionStorage.setItem getSessionVariableKey(placeId), value

class Groupon.FollowMerchant

  constructor: (@el, @csrf, @placeId, @showNearbyPlaces, @nearbyPlaceIds) ->
    @rootUrl = '/merchant-page'
    @$container = $(@el)
    @$followButton = @$container.find '.follow-text-container'
    @$unfollowButton = @$container.find '.unfollow-text-container'
    @$countContainer = @$container.find '.follow-count-container'
    @$countSpan = @$container.find '.follow-count-span'
    @$flyoutContainer = @$container.find '.follow-help-container'
    @$gotItButton = @$container.find '.got-it'

    @followCounter = @$container.data().followCount

    @isFollowing = @$followButton.is ':hidden'

    @hasMainFollowWidget = $('.mpp-container .follow-merchant-main-content').length > 0

    @updateFlyoutDisplay()
    @bindEventHandlers()

    $(window).load =>
      ## if we have an automatic action pending
      followAction = getFromStorage @placeId
      removeFromStorage @placeId
      switch followAction
        when 'follow'
          @followMerchant(false, true)
        when 'unfollow'
          @unfollowMerchant(true)

  updateFlyoutDisplay: ->
    if localStorage?.getItem(FOLLOW_FLYOUT_LOCALSTORAGE_KEY) is 'true' or @isFollowing
      @$flyoutContainer.remove()
    else
      @$flyoutContainer.removeClass 'hide'

  setFlyoutLocalStorage: ->
    localStorage?.setItem FOLLOW_FLYOUT_LOCALSTORAGE_KEY, 'true'
    @updateFlyoutDisplay()

  bindEventHandlers: ->
    $(document).ready =>
      @$followButton.click => @followMerchant()
      @$countContainer.click => @followMerchant()
      @$unfollowButton.click => @unfollowMerchant()
      @$gotItButton.click => @setFlyoutLocalStorage()

      # listen to request a deal requests
      if @hasMainFollowWidget
        $('.follow-merchant-main-content').on 'follow-requested', (event) =>
          @followMerchant true

      $('.request-deal').on 'deal-requested', (event) =>
        @switchToFollowing()

  switchToFollowing: ->
    @isFollowing = true

    @$unfollowButton.removeClass 'hide'
    @$followButton.addClass 'hide'
    @$countContainer.addClass 'hide'

    @setFlyoutLocalStorage()

  switchToNotFollowing: ->
    @isFollowing = false

    @$followButton.removeClass 'hide'
    @$countContainer.removeClass 'hide'
    @$unfollowButton.addClass 'hide'

  followMerchant: (mainWidgetRequest = false, triggeredOnPageLoad = false) ->
    return if @isMakingAPIRequest
    @isMakingAPIRequest = true

    if not mainWidgetRequest
      @switchToFollowing()
      @$container.trigger('follow-successful') if @hasMainFollowWidget

    obj =
      _csrf: @csrf
      placeId: @placeId
      triggeredOnPageLoad: triggeredOnPageLoad
      nearbyPlaceIds: @nearbyPlaceIds if mainWidgetRequest and @showNearbyPlaces and $(window).width() > MIN_MODAL_WIDTH

    $.ajax
      url: "#{@rootUrl}/follow-merchant"
      type: 'POST'
      contentType: 'application/json'
      dataType: 'json'
      data: JSON.stringify obj
      success: (res) =>
        if res.result isnt 'ok'
          @switchToNotFollowing()
          @$container.trigger 'follow-unsuccessful'

        return setToStorage(@placeId, 'follow') if MPP.JsonResponseHandler.loginRequired res

        return unless res.result is 'ok'

        if mainWidgetRequest
          @switchToFollowing()
          @$container.trigger 'follow-successful', [res.data]
      error: =>
        @switchToNotFollowing()
        if mainWidgetRequest
          @$container.trigger 'follow-unsuccessful'
      complete: =>
        @isMakingAPIRequest = false


  unfollowMerchant: (triggeredOnPageLoad = false) ->
    return if @isMakingAPIRequest
    @isMakingAPIRequest = true

    @switchToNotFollowing()
    if @hasMainFollowWidget
      @$container.trigger 'unfollow-successful'
      @hasMainFollowWidget = false

    obj =
      _csrf: @csrf
      placeId: @placeId
      triggeredOnPageLoad: triggeredOnPageLoad

    $.ajax
      url: "#{@rootUrl}/follow-merchant/delete"
      type: 'POST'
      contentType: 'application/json'
      dataType: 'json'
      data: JSON.stringify obj
      success: (res) =>
        if res.result isnt 'ok'
          @switchToFollowing()
          @$container.trigger 'follow-unsuccessful'

        return setToStorage(@placeId, 'unfollow') if MPP.JsonResponseHandler.loginRequired res

        return @switchToFollowing() unless res.result is 'ok'
      error: =>
        @switchToFollowing()
      complete: =>
        @isMakingAPIRequest = false


$ ->
  el = '.follow-merchant-righthand-module'
  return unless $(el).length > 0

  place = $('.mpp-container').data()
  followConfig = $(el).data()
  csrfToken = $('meta[name=csrf-token]').attr('content')

  new Groupon.FollowMerchant(
    el,
    csrfToken,
    place.placeId,
    followConfig.showNearbyPlaces,
    followConfig.nearbyPlaceIds
  )

  if followConfig.displayFollowMainWidget
    new Groupon.FollowMerchantMainContent(
      '.follow-merchant-main-content',
      csrfToken,
      followConfig.showNearbyPlaces
    )
